import { useTheme } from '@mui/material';
export const useBDrawerStyles = (fullHeight = false) => {
    const theme = useTheme();
    return {
        drawerPaper: {
            ...(fullHeight
                ? {
                    height: '100%',
                    maxHeight: '100%',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0
                }
                : {
                    borderTopLeftRadius: '40px',
                    borderTopRightRadius: '40px',
                    maxHeight: '80vh'
                }),
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.common.white
        },
        topBar: {
            display: 'flex',
            justifyContent: 'center',
            py: 1.5
        },
        indicator: {
            width: 88,
            height: 6,
            borderRadius: 2.5,
            backgroundColor: '#E1E1E1'
        },
        headerContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 16px 8px 16px',
            position: 'relative'
        },
        headerContainerCentered: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            py: 1.5,
            px: 2,
            position: 'relative',
            minHeight: 48
        },
        titleContainer: {
            flex: 1,
            ...theme.typography.h4,
            color: theme.palette.text.primary
        },
        closeButton: {
            border: 'none',
            color: theme.palette.action.active,
            '&:hover': {
                backgroundColor: theme.palette.grey[100]
            }
        },
        contentContainer: {
            flex: 1,
            px: 2,
            py: 1,
            overflowY: 'auto',
            ...(fullHeight
                ? { minHeight: 0, maxHeight: 'none', display: 'flex', flexDirection: 'column' }
                : { maxHeight: 'calc(100vh - 160px)' })
        },
        contentWithBottomPadding: {
            flex: 1,
            px: 2,
            overflowY: 'auto',
            ...(fullHeight
                ? { minHeight: 0, maxHeight: 'none', display: 'flex', flexDirection: 'column' }
                : { maxHeight: 'calc(100vh - 120px)' })
        },
        bottomBar: {
            display: 'flex',
            justifyContent: 'center',
            pb: 1.5
        }
    };
};
